import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    target: { type: String, default: "body" }
  }
  
  scrollToPagination(event) {
    // This action only gets called by pagination links, not filters
    requestAnimationFrame(() => {
      const element = this.targetValue === "body" ? document.body : document.querySelector(this.targetValue)
      if (element) {
        element.scrollIntoView({ behavior: "instant", block: "start" })
      }
    })
  }
}